import React from 'react'

export default function MostrarHistorico({
  consumoNoCicloDash,
  setConsumoNoCicloDash,
  setLabelDashboardConsumo,
  handleCancelar,
  notHasSharedPlan,
  openAlertaSharedPlan,
  showHistoricoConsumo
}) {
  const handleToggleHistorico = () => {
    if (notHasSharedPlan) {
      openAlertaSharedPlan()
      handleCancelar()
      return
    }

    if (consumoNoCicloDash === 'default') {
      setConsumoNoCicloDash('historico')
      setLabelDashboardConsumo('Histórico de consumo do plano compartilhado')
    } else {
      setConsumoNoCicloDash('default')
      setLabelDashboardConsumo('Consumo nos ciclos')
    }
    handleCancelar()
  }

  return (
    <li>
      <div
        className={`${showHistoricoConsumo ? 'drop-acoes-menu-dashboard-dispositivos-consumo' : 'drop-acoes-menu'} item-drop-acoes-hover`}
      >
        <span
          className="drop-acoes-menu-label fonte-cor-1"
          onClick={handleToggleHistorico}
        >
          {consumoNoCicloDash === 'default'
            ? 'Mostrar histórico de plano compartilhado'
            : 'Mostrar consumo no ciclo'}
        </span>
      </div>
    </li>
  )
}
